



























































































































import { Component, Vue } from 'vue-property-decorator';
import { getCollegeList, userAttest, teachClass, relationTeachClass, getUserAgencyInfo, dismissUserAgency, setUserAgency } from '@/apis/myInfo/myInfo.ts';
import { UserInfo } from '@/interfaces/vuexStateInterface';

import { Dialog, Toast } from 'vant';
import { objCookie } from '@/utils/common';
import i18n from '@/lang';

// 已认证列表中单个机构信息参数
interface agencyCertificationItem {
  // 机构名
  jigou: string;
  // 机构ID
  jigouid: string;
  // 认证姓名
  realname: string;
  // 认证工号
  realstno: string;
}

@Component({})
export default class MyMechanism extends Vue {
  private show: boolean = false;
  // 所在机构姓名
  private name: string = '';
  // 所在机构id
  private stno: string = '';
  private mechan: string = '';
  // 选项下标 -2 暂无课程
  private isSchool: number = -1;
  private schoolList: any = [];
  private searchValue: string = ''; //输入搜索的内容
  private sureSchool: string | undefined = ''; //渲染上去的学校
  private Chooselesson: boolean = false;
  private lessonClass: string = i18n.t('ktpMy.选择学校机构') as string; //弹框中间数据
  private lessList: any = '';
  // 机构ID
  private schoolId: string = '';
  private oldMechanismId: string = '';
  // 显示已认证机构的列表： true- 显示列表、false - 显示添加认证机构
  private showList: boolean = true;
  // 从机构列表点击去的
  private showCancleAuth: boolean = false;
  // 认证状态
  private atteststate: string = '0';

  // 已认证列表
  agencyCertificationList: agencyCertificationItem[] = [];

  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }

  private classIndex: number = 0; //保留点击的index

  disposePopDialogTitle(){
    if(this.Chooselesson){
      this.lessonClass = i18n.t('ktpMy.绑定课程') as string;
    }else{
      this.lessonClass = i18n.t('ktpMy.选择学校机构') as string;
    }
  }

  //确认认证
  submit() {
    let arrId: any = [];
    for (let i = 0; i < this.lessList.length; i++) {
      const item = this.lessList[i];
      if (item.classid != '0') {
        arrId.push({
          teachClassid: item.id,
          classid: item.classid
        });
      }
    }
    const length = this.lessList.length - arrId.length;
    if (!length) {
      this.bingdingCourse(arrId, 0);
      return;
    }
    Dialog.confirm({
      title:  i18n.t('ktpMy.确认自动创建课程') as string,
      message: `${i18n.t('ktpMy.有')} ${length} ${i18n.t('ktpMy.门排课课程未进行绑定')},"<span style="color: #4285F4">${i18n.t('ktpMy.系统将自动创建对应课程')}</span>"`,
      cancelButtonText: i18n.t('ktpMy.暂不创建') as string,
      confirmButtonText: i18n.t('ktpMy.确认创建') as string
    }).then(() => {
      this.bingdingCourse(arrId, 1);
    }).catch(() => {
      this.bingdingCourse(arrId, 0);
    });
  }

  // 绑定课程
  bingdingCourse(classArray: any, isAutoCreate: number) {
    relationTeachClass({ classArray, isAutoCreate, coid: this.schoolId }).then((res) => {
      Toast.success();
      this.cancelAuthentication()
    }).catch((e) => {
      Toast.fail(i18n.t('ktpMy.绑定失败'));
    }).finally(()=> {
      this.initMechanismParams();
    });
  }

  //下一步
  next() {
    if(this.showCancleAuth) {
      this.setUserAgency();
      return;
    }
    if (this.userInfo.usertype == '1') {
      if (this.name != '' && this.stno != '' && this.sureSchool != '') {
        //全部输入
        //点击下一步
        userAttest({
          coid: this.schoolId,
          name: this.name,
          stno: this.stno
        })
          .then(async (res: any) => {
            if(this.atteststate != '2') {
              Toast.success(i18n.t('ktpMy.认证成功'));
            }
            await this.$store.dispatch('setUserInfo');
            this.schoolId = res.coid;
            if (this.atteststate > '0') {
              this.atteststate = '';
              res.list.length === 0 && await this.cancelAuthentication();
            }
            if(res.length) {
              this.setNav();
              this.Chooselesson = true;
              this.disposePopDialogTitle();
              this.lessList = res.list;
            } else {
              this.initMechanismParams();
            }
          })
          .catch((err) => {
            Toast.fail(err.message);
          });
      } else {
        return;
      }
    } else {
      userAttest({
        coid: this.schoolId,
        name: this.name,
        stno: this.stno
      }).then(async (res: any) => {
        if(this.atteststate != '2') {
          Toast.success(i18n.t('ktpMy.认证成功'));
        }
        await this.$store.dispatch('setUserInfo');
        if (sessionStorage.courseids && sessionStorage.coid) {
          this.$router.push('/ktpCourse');
        }
        if (this.atteststate > '0') {
          this.atteststate = '';
          res.list.length === 0 && await this.cancelAuthentication();
          this.setNav();
          this.Chooselesson = true;
          this.lessList = res.list;
        } else {
          this.$router.back()
        }
      }).catch((e) => {
        Toast.fail(e.message);
        this.$router.push({
          path: '/courseDoor',
          query: {
            coid: sessionStorage.coid
          }
        });
        sessionStorage.removeItem('courseids');
        sessionStorage.removeItem('coid');
      });
    }
  }

  // 设置老师认证的返回流程
  setNav() {
    const back = () => {
      if (this.userInfo.atteststate == '0') {
        this.initMechanismParams();
        this.sureSchool = this.userInfo.attestInfo!.jigou;
        this.lessonClass = i18n.t('ktpMy.选择学校机构') as string;
        this.getSchool('');
        this.$setNavInfo({
          type: 'normal',
          title: i18n.t('ktpMy.机构用户认证') as string,
          showTitle: true,
          backConfig: () => {
            this.cancelAuthentication();
          }
        });
      } else {
        this.cancelAuthentication();
      }
    };
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.绑定课程') as string,
      showTitle: true,
      backConfig: back
    });
  }

  showClass(index: number) {
    if(this.userInfo.usertype == '0'){return;}
    this.show = true;
    this.classIndex = index;
    teachClass({
      option: 0,
      isRelationCollege: 0
    }).then((res: any) => {
        this.schoolList = res;
      })
  }

  showPopup() {
    this.show = true;
    this.$nextTick(()=> {
      const input: HTMLInputElement | null = this.$refs['schoolInput'] as HTMLInputElement;
      input && input.focus();
    });
  }

  chooseSchoole(index: number) {
    this.isSchool = index;
    //选择课程时
    if (this.Chooselesson) {
      if (index == -2) {
        this.lessList[this.classIndex].coursename = i18n.t('ktpMy.暂无课程') as string;
        this.lessList[this.classIndex].classid = '';
      } else {
        this.lessList[this.classIndex].coursename = this.schoolList[index].coursename;
        this.lessList[this.classIndex].classid = this.schoolList[index].id;
      }
    } else {
      //选择学校时
      this.sureSchool = this.schoolList[index].name;
      this.schoolId = this.schoolList[index].coid;
    }
  }

  search() {
    this.getSchool(this.searchValue);
  }

  //确定学校
  fixSchool() {
    if (this.schoolList == '') {
      this.sureSchool = this.searchValue;
    }
    this.show = false;
  }

  created() {
    if(this.userInfo.atteststate!=undefined && this.userInfo.atteststate!=null && this.userInfo.atteststate != '0') {
      this.getAgencyCertificationList();
      this.showList = true;
    } else {
      this.showList = false;
    }

    if (this.$route.query.atteststate!=null && this.$route.query.atteststate!="" && this.$route.query?.atteststate) {
      this.atteststate = this.$route.query.atteststate as string;
    }
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.机构用户认证') as string,
      showTitle: true,
      backConfig: () => {
        if (this.atteststate === '1') {
          this.cancelAuthentication();
        } else {
          this.$router.back();
        }
      }
    });
    if(this.searchValue == ""){
      this.searchValue = (this.userInfo.school!=undefined)?this.userInfo.school:'';
    }
    this.getSchool(this.searchValue);
  }

  // 获取机构认证列表
  getAgencyCertificationList() {
    getUserAgencyInfo().then((res: any) => {
      if(res.length) {
        this.agencyCertificationList = res;
      }
    })
  }

  // 更改机构
  setUserAgency() {
    setUserAgency({
      source_coid: this.oldMechanismId,
      coid: this.schoolId,
      name: this.name,
      stno: this.stno
    }).then(async (res: any) => {
      Toast.success(i18n.t('ktpMy.认证成功'));
      this.getAgencyCertificationList();
      if(res.length) {
        await this.$store.dispatch('setUserInfo');
        this.schoolId = res.coid;
        this.setNav();
        this.Chooselesson = true;
        this.disposePopDialogTitle();
        this.lessList = res.list;
      } else {
        this.initMechanismParams();
      }
    });
  }
  // 获课程列表
  getCourseList() {
    this.lessList = [];
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: i18n.t('Common.加载中') as string,
    });
    userAttest({
      coid: this.schoolId,
      name: this.name,
      stno: this.stno
    }).then(async (res: any) => {
      await this.$store.dispatch('setUserInfo');
      this.schoolId = res.coid;
      this.getAgencyCertificationList();
      this.showList = false;
      this.Chooselesson = true;
      this.disposePopDialogTitle();
      this.lessList = res.list;
    }).finally(() => {
      Toast.clear()
    })
  }
  // 查看机构信息
  viewMechanismInfo(item: agencyCertificationItem) {
    this.clickMechanismItem(item)
  }
  // 查看机构编排的课程
  viewMechanismCourse(item: agencyCertificationItem) {
    this.clickMechanismItem(item);
    this.Chooselesson = true;
    this.disposePopDialogTitle();
    this.getCourseList();
  }
  // 点击机构列表项
  clickMechanismItem(item: agencyCertificationItem) {
    this.showCancleAuth = true;
    this.showList = false;
    this.name = item.realname;
    this.stno = item.realstno;
    this.schoolId = item.jigouid;
    this.sureSchool = item.jigou;
    this.$setNavInfo({
      backConfig: () => {
        this.initMechanismParams();
      }
    })
  }
  // 初始化机构参数
  initMechanismParams() {
    this.showCancleAuth = false;
    this.showList = true;
    this.name = '';
    this.stno = '';
    this.schoolId = '';
    this.sureSchool = '';
    this.Chooselesson = false;
    this.disposePopDialogTitle();
    this.getAgencyCertificationList();
    this.$setNavInfo({
      title: i18n.t('ktpMy.机构用户认证') as string,
      backConfig: () => {
        this.$router.back();
      }
    })
  }
  // 获取机构列表
  getSchool(searchValue: string) {
    getCollegeList({ search: searchValue })
      .then((res:any) => {
        this.schoolList = res;
      })
  }
  // 解除认证
  dismissUserAgency() {
    Dialog.confirm({
      title: i18n.t('ktpMy.已取消账号绑定') as string,
      confirmButtonText: i18n.t('Home.确认') as string,
    }).then(() => {
      dismissUserAgency({
        coid: this.schoolId,
        name: this.name,
        stno: this.stno
      }).then(() => {
        this.initMechanismParams();
      })
    });
  }
  // 取消认证
  async cancelAuthentication() {
    if (this.atteststate == '1') {
      const expires = (8.64e7 - Date.now() % 8.64e7) / 8.64e7;
      objCookie.setCookie('isAuthentication', '0', expires);
      await Dialog.confirm({
        title: i18n.t('ktpMy.已取消账号绑定') as string,
        message: `${i18n.t('ktpMy.可在个人中心处继续完成绑定流程')}`,
        confirmButtonText: i18n.t('Home.确认') as string,
        showCancelButton: false
      });
    }
    sessionStorage.isAuthentication = '0';
    this.$router.back();
  }
}
